module.exports = __webpack_public_path__ + "img/9788954617932.37a40f92.jpg";